module.exports = __webpack_public_path__ + "static/img/1548670469471749483.315fe6e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/picture/1548670469471749483.jpg
// module id = 3V/E
// module chunks = 0